import React from "react";
import PropTypes from "prop-types";
import { Settings as StripesSettings } from "@folio/stripes/smart-components";

export default class Settings extends React.Component {
  static propTypes = {
    stripes: PropTypes.shape({
      connect: PropTypes.func,
    }).isRequired,
    match: PropTypes.object.isRequired,
  };

  pages = [];

  render() {
    return (
      <StripesSettings
        {...this.props}
        pages={this.pages}
        paneTitle="Legal Deposits"
      />
    );
  }
}
